import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets retained browser scroll after SPA route changes so each page opens at the top.
const ScrollToTop = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        const resetScroll = () => {
            window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            document.scrollingElement?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            document.getElementById('main-content')?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        };

        resetScroll();
        const animationFrameId = window.requestAnimationFrame(resetScroll);

        return () => {
            window.cancelAnimationFrame(animationFrameId);
        };
    }, [location.key]);

    return null;
};

export default ScrollToTop;
